import "./index.scss";

const NotFound = () => {
  return (
    <div className="notfound-main">
      <p>页面丢失了</p>
      <img
        src="https://yd-crm-mini-prod-oss.oss-cn-shanghai.aliyuncs.com/sfa/empty_data.png"
        alt=""
      />
    </div>
  );
};

export default NotFound;
